const NotFoundPage = () => {
    return (
        <h1>This page does not exist...</h1>
    );
};

export default NotFoundPage;
